import type { SignUpFormData } from '@/models/auth.model';

export const authV2Signup = async (signUpFormData: SignUpFormData) => {
  const baseUrl = process.env.NEXT_PUBLIC_BACKEND_BASE_URL;

  return await fetch(`${baseUrl}/auth_v2/signup`, {
    method: 'POST',
    body: JSON.stringify(signUpFormData),
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};
